import { Grid, Typography } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { routeName } from '../../../routes/routeName'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms'
import { alertActive, swalActive, swalError, swalSuccess } from '../../../components/alert/swal'
import InputDatePicker from '../../../components/input/inputDatePicker'
import InputTextField from '../../../components/input/inputTextField'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import { PublishOnlineCourseApi } from '../../../api/publish-online-course/publish-online-course.api'
import { handleTypingNumber } from '../../../utils/app.utils'
import moment from 'moment'
import { dateToView } from '../../../utils/date.utils'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { MyOnlineCourseShoppingCartApi } from '../../../api/my_online_course_shopping_cart/my_online_course_shopping_cart.api'
import { useDispatch, useSelector } from 'react-redux'
import { PaymentChannelApi } from '../../../api/payment-channel/payment-channel.api'
import { bankListArray } from '../../cms/course-online/manage-payment-channel/enum/manage_payment'

export default function PaymentOnlineCourse() {
    const fileRef = useRef<any>()
    const navigate: NavigateFunction = useNavigate();
    const dispatch = useDispatch();
    const { profile } = useSelector((state: any) => state.profile);

    const [file, setFile] = useState<any>();
    const [filePath, setFilePath] = useState<any>();
    const [payment_date, set_payment_date] = useState<any>('');
    const [payment_time, set_payment_time] = useState<any>('');
    const [payment_amount, set_payment_amount] = useState<any>('');
    const [detail, setDetail] = useState<any>()
    const [basicInfo, setBasicInfo] = useState<any>()
    const [data, setData] = useState<any[]>([]);

    const { id } = useParams();
    const getDetail = async () => {

        const res = await PublishOnlineCourseApi.id(id);
        const data = res.data
        if (res.status < 300) {
            setDetail(data?.data)
            setBasicInfo(data?.data?.basic_info?.data)
        }
    }
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {

            const res = await MyOnlineCourseShoppingCartApi.list();
            const data = res.data
            if (data) {
                setData(data);

                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);
    const [formState, setFormState] = useState({
        account_name_eng: "",
        account_name_th: "",
        account_no: "",
        account_type: "",
        application_fee: "",
        bank_name_eng: "",
        bank_name_th: "",
        id_payment_channels: null,
        payment_channels_name: "",
        payment_channels_type: "",
        term_fee: ""
    })
    const [file_bank, set_file_bank] = useState<any>(null);
    const [select_bank, set_select_bank] = useState<any>(null);
    const handleGetDetail = async () => {
        dispatch(setLoading());
        await PaymentChannelApi.getPaymentChannelByType({ type_channel_payment: "ONLINE_COURSE" }).then((res) => {
            if (res.status < 300) {
                const paymentChannel = res.data?.data?.paymentChannel;
                setFormState((prev) => ({ ...prev, ...paymentChannel }));
                set_file_bank(res.data?.data?.lastFile)
                if (paymentChannel?.bank_name_th) {
                    const data_value = bankListArray?.find((x) => x.name === paymentChannel?.bank_name_th) || null
                    set_select_bank(data_value);
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    useEffect(() => {
        if (id) {
            getDetail()

        }
        handleGetDetail()
    }, [])

    const onImageChange = (event: any) => {
        if (event.target.files && event.target.files[0]) {
            setFile(event.target.files[0]);
            setFilePath(URL.createObjectURL(event.target.files[0]))
        }
    }
    const handleDeleteAll = async () => {
        await MyOnlineCourseShoppingCartApi.delete().then((res: any) => {
            if (res.status < 300) {
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    const handleSubmit = async () => {

        const formData = new FormData();

        //DRAFT
        formData.append('file', file);
        formData.append('payment_date_time', `${payment_date}T${payment_time}`);

        formData.append('payment_amount', payment_amount);
        for (let i = 0; i < data.length; i++) {
            formData.append("id_online_courses", data[i].id_online_course); // "files" should match your backend field name
        }
        await PublishOnlineCourseApi.purchaseAll(formData).then((res: any) => {
            if (res.status < 300) {
                // swalSuccess('บันทึกวุฒิบัตร', 'บันทึกวุฒิบัตร เรียบร้อยแล้ว')
                // alertActive('บันทึกวุฒิบัตร', 'บันทึกวุฒิบัตร เรียบร้อยแล้ว', 'ดูตัวอย่าง', 'ตกลง', () => {
                // handleSubmit()
                // reactToPrintFn()
                handleDeleteAll()
                swalSuccess('ยืนยันการชำระเงิน เรียบร้อยแล้ว', undefined, undefined, () => {
                    navigate(routeName.students.MyOnlineCourse)
                })


                // }, 'info',)
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })


    }
    return (
        <div className="h-auto">
            <NavigateListCustom
                navigateData={[
                    {
                        name: "ระบบคอร์สออนไลน์",
                        key: "1",
                        pathName: routeName.students.ShoppingCart,
                    },
                    {
                        name: "ตะกร้าสินค้า",
                        key: "2",
                        pathName: routeName.students.ShoppingCart,
                    },
                    {
                        name: "ชำระเงิน",
                        key: "3",
                        pathName: routeName.students.PaymentOnlineAllCourse,
                    },

                ]}
            />
            <div className="w-full flex justify-end mt-[40px]">
                <div className="flex gap-4">
                    <ButtonOutlined
                        onClick={() => {
                            navigate(routeName.students.ShoppingCart)
                        }}
                        buttonName={'ยกเลิก'}
                        btnProps={{
                            width: "100px"
                        }}
                    />
                    <ButtonPrimary
                        onClick={() => {
                            swalActive('ยืนยันการชำระเงิน', 'ท่านต้องการยืนยันการชำระเงิน ใช่หรือไม่', () => {
                                handleSubmit()
                            }, 'info', 'ยืนยัน')
                        }}
                        mode="add"
                        buttonName={'ยืนยัน'}
                        btnProps={{
                            width: "100px"
                        }}
                    />
                </div>
            </div>
            {/* header */}
            <section className="my-4">
                <Typography variant="h3">ชำระเงิน</Typography>
            </section>

            <section className="my-4">
                <Grid container spacing={2}>
                    <Grid item lg={4}>
                        <div style={{
                            background: "#F6F6F6",
                            padding: '40px',
                            borderRadius: '16px', display: 'flex', flexDirection: 'column', justifyContent: "space-between", maxHeight: "560px", height: '100%'
                        }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: '10px' }}>
                                {/* <Typography variant='h5'>บิลเลขที่ 00000001</Typography> */}
                                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                    <Typography sx={{ fontWeight: "600" }}>ชื่อลูกค้า</Typography>
                                    <Typography>{profile?.title} {profile?.student_frist_name} {profile?.student_last_name}</Typography>
                                </div>
                                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                    <Typography sx={{ fontWeight: "600" }}>ออกบิลเมื่อ</Typography>
                                    <Typography>{dateToView(new Date())}</Typography>
                                </div>
                                {/* <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                    <Typography sx={{ fontWeight: "600" }}>กรุณาชำระก่อน</Typography>
                                    <Typography>{dateToView(new Date().setDate((new Date().getDate() + basicInfo?.online_course_pay_within_day)))}</Typography>
                                </div> */}
                                <div style={{ borderBottom: "2px dashed #e7e7e7", margin: '20px 0px' }}></div>
                                <div style={{
                                    height: '330px',
                                    overflowY: 'auto'
                                }}>
                                    {data.map((x) => {
                                        return (
                                            <>
                                                <Typography sx={{ fontWeight: "600" }}>{x?.online_course_no}</Typography>
                                                <Typography sx={{ fontWeight: "600" }}>{x?.online_course_name}</Typography>
                                                <Typography>{x?.online_course_teacher}</Typography>
                                                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                    <Typography sx={{ fontWeight: "600" }}>จำนวน 1 รายการ</Typography>
                                                    <Typography>{x?.online_course_amount} บาท</Typography>
                                                </div>
                                                <div style={{ borderBottom: "2px dashed #e7e7e7", margin: '20px 0px' }}></div>
                                            </>
                                        )
                                    })}
                                </div>


                            </div>
                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                <Typography variant='h5' sx={{ fontWeight: "600" }}>ยอดสุทธิ</Typography>
                                <Typography variant='h5' sx={{ fontWeight: "600" }}>{data?.reduce((a: number, v: any) => a = a + Number(v.online_course_amount), 0)} บาท</Typography>
                            </div>
                        </div>
                    </Grid>
                    <Grid item lg={4}>
                        <div style={{
                            background: "#F6F6F6",
                            padding: '40px',
                            borderRadius: '16px', display: 'flex', flexDirection: 'column', justifyContent: "space-between", maxHeight: "560px", height: '100%'
                        }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: '10px' }}>
                                <Typography variant='h5'>ช่องทางการชำระเงิน</Typography>
                                <img src={select_bank?.icon} alt={select_bank?.symbol}  style={{ width: '100%', height: '250px', objectFit: 'contain' }} />
                                {/* <img src={`${process.env.REACT_APP_FILE_BASE_API}/${file_bank?.file_path}`} style={{ width: '100%', height: '250px', objectFit: 'contain' }} /> */}
                                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                    <Typography sx={{ fontWeight: "600" }}>ชื่อบัญชี</Typography>
                                    <Typography sx={{ fontWeight: "600" }}>{formState?.account_name_th}</Typography>
                                </div>
                                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                    <Typography sx={{ fontWeight: "600" }}>Account Name</Typography>
                                    <Typography sx={{ fontWeight: "600" }}>{formState?.account_name_eng}</Typography>
                                </div>
                                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
                                    <div>
                                        <Typography >เลขที่บัญชี</Typography>
                                        <Typography >Account No.</Typography>
                                    </div>
                                    <Typography variant='h5' sx={{ fontWeight: "600" }}>{formState?.account_no}</Typography>
                                </div>
                                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                    <Typography sx={{ fontWeight: "600" }}>Account Type</Typography>
                                    <Typography sx={{ fontWeight: "600" }}>{formState?.account_type}</Typography>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </Grid>
                    <Grid item lg={4}>
                        <div style={{
                            // padding: '40px',
                            borderRadius: '16px', display: 'flex', flexDirection: 'column', justifyContent: "space-between", maxHeight: "560px", height: '100%'
                        }}>
                            <div style={{
                                borderRadius: '10px',
                                border: "1px solid #7e7e7e",
                                // height: "600px",
                                display: "flex",
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: "40px"
                            }}>

                                {filePath ? <img src={filePath} onClick={() => fileRef.current.click()} /> : <img onClick={() => fileRef.current.click()} src={'https://placehold.co/500x500?text=No+Image'} />}
                                <input ref={fileRef} className='hidden' type='file' accept={"image/*"} onChange={(e: any) => onImageChange(e)} />
                            </div>
                            <div style={{ display: 'flex', gap: '10px', marginTop:'20px' }}>
                                <div>
                                    <InputDatePicker heading='วันที่ชำระเงิน' value={payment_date} onChange={(e) => {
                                        set_payment_date(moment(e).format("yyyy-MM-DD"))
                                    }} />
                                </div>
                                <div>
                                    <InputTextField heading='เวลาชำระเงิน' type='time' value={payment_time} onchange={(e) => {
                                        set_payment_time(e.target.value)
                                    }} />
                                </div>
                                <div>
                                    <InputTextField heading='ยอดเงิน (บาท)' value={payment_amount} onchange={(e) => {
                                        set_payment_amount(e.target.value)
                                    }}
                                        onkeypress={handleTypingNumber} />
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </section>
        </div>
    )
}
